export function effects($, TweenLite, imagesLoaded) {

  const body = document.body;
  const docEl = document.documentElement;
  const hero = document.querySelector('.module--hero');
  const modularHero = document.querySelector('.modularpage__header');


  let winsize;
  const calcWinsize = () => winsize = { width: window.innerWidth, height: window.innerHeight };
  calcWinsize();
  window.addEventListener('resize', calcWinsize);


  // Start with polyfill
  const StartsWithPolyfill = {

    get: (string1,string2) => {
      if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(string2, position) {
          position = position || 0;
          return string1.indexOf(string2, position) === position;
        };
      } else {
        return string1.startsWith(string2);
      }
    }

  };

  /*const getMousePos = (ev) => {
      let posx = 0;
      let posy = 0;
      if (!ev) ev = window.event;
      if (ev.pageX || ev.pageY) {
          posx = ev.pageX;
          posy = ev.pageY;
      }
      else if (ev.clientX || ev.clientY) 	{
          posx = ev.clientX + body.scrollLeft + docEl.scrollLeft;
          posy = ev.clientY + body.scrollTop + docEl.scrollTop;
      }
      return {x: posx, y: posy};
  };

  let mousePos = {x: winsize.width/2, y: winsize.height/2};

  if (hero != null) {
    hero.addEventListener('mousemove', ev => mousePos = getMousePos(ev));
  } else if (modularHero != null) {
    modularHero.addEventListener('mousemove', ev => mousePos = getMousePos(ev));
  }
  */

  document.fonts.ready.then(function () {

    //----------------------------------------------------
    // Loaded
    //----------------------------------------------------

    imagesLoaded( 'body', { background: true }, function() {
      $('html').addClass('htmlReady');
    });
  });

  function createButtons() {
    $('.js-add-button--blob').each(function(i, e) {
      var isInput = $(e).children('input').length;

      var iconClass = $.grep(this.className.split(" "), function(v, i){
        if (StartsWithPolyfill.get(v, 'js--icon')) {
          return v;
        }
      }).join();

      iconClass = iconClass.replace('js--icon-', '')

      var iconHTML = (iconClass !== '') ? '<span class="icon icon-'+iconClass+'" aria-hidden="true"></span>' : '';
      var iconParent = (iconClass !== '') ? 'button-icon' : '';

      if (isInput) {
        var text = $(e).children().val();
        $(e).addClass('button button--blob' + ' ' + iconParent).append(iconHTML +'<span class="button__inner">'+text+'</span><span class="button__bg" style="filter: url(\'#filter-goo-4\')"><span class="blob"></span><span class="blob"></span><span class="blob"></span><span class="blob"></span></span>').children().val('');
      } else {
        var text = $(e).children('a, button').text();
        $(e).children('a, button').text('').addClass('button button--blob' + ' ' + iconParent).append(iconHTML+'<span class="button__inner">'+text+'</span><span class="button__bg" style="filter: url(\'#filter-goo-4\')"><span class="blob"></span><span class="blob"></span><span class="blob"></span><span class="blob"></span></span>');

      }

   });
  }

//FORM

  $(document).ready(function () {
    $('.js-add-button--blob').each(function (i, e) {
      let isInput = $(e).children('input').length;
      if (isInput && $(e).children('input').attr('disabled') == "disabled") {
        $(e).addClass('disabled');
      }
    });

  });

  let thisInput  = false
  $('.form__field--checkbox').change(function () {
    thisInput = !thisInput;

    if (thisInput) {
      console.log($(this).closest('.form__row').find('.js-add-button--blob').find('input'));
      $(this).closest('.form__row').find('.js-add-button--blob').find('input').removeAttr('disabled');
      $(thisInput).removeAttr('disabled');
      $(this).closest('.form__row').find('.js-add-button--blob').removeClass('disabled');
    }
    else {
      $(thisInput).attr('disabled', 'disabled');
      $(this).closest('.form__row').find('.js-add-button--blob').find('input').attr('disabled', 'disabled');
      $(this).closest('.form__row').find('.js-add-button--blob').addClass('disabled')
    }
  });

  createButtons();

  /*
  function initBtBlob(el) {
    var bt = el.querySelector('.button__inner');
    var bg = el.querySelector('.button__bg');
    var blob = el.querySelectorAll('.blob');
    var filter = document.querySelector('.button-svg-filters');

    var x = 20.7;
    var y = 0.5;

    TweenLite.to(blob[1], 4.2, { x: x, y: y, ease: Elastic.easeOut.config(1, 0.1) });
    TweenLite.to(blob[2], 2.8, { x: x, y: -y, ease: Elastic.easeOut.config(1, 0.1) });
    TweenLite.to(blob[3], 2.8, { x: -x, y: -y, ease: Elastic.easeOut.config(1, 0.1) });
    TweenLite.to(filter, 5, { onUpdate: function() { filter.setAttribute('x', 0); }});

    bt.addEventListener('mousemove', function(e) {

      var rect = el.getBoundingClientRect();
      //var x = (e.pageX - el.offsetLeft - el.offsetWidth / 2) * 0.6;
      var x = (e.clientX - rect.left - el.offsetWidth / 2) * 0.6;
      //var y = (e.pageY - el.offsetTop - el.offsetHeight / 2) * 0.6;
      var y = (e.clientY - rect.top - el.offsetHeight / 2) * 0.6; // This way fixes button in fixed items

      TweenLite.to(blob[1], 4.2, { x: x, y: y, ease: Elastic.easeOut.config(1, 0.1) });
      TweenLite.to(blob[2], 2.8, { x: x, y: -y, ease: Elastic.easeOut.config(1, 0.1) });
      TweenLite.to(blob[3], 2.8, { x: -x, y: -y, ease: Elastic.easeOut.config(1, 0.1) });
      TweenLite.to(filter, 5, { onUpdate: function() { filter.setAttribute('x', 0); }});
    });
    bt.addEventListener('mouseout', function(e) {
      var x = 19;
      var y = 21;
      TweenLite.to(blob[1], 4.2, { x: x, y: y, ease: Elastic.easeOut.config(1, 0.1) });
      TweenLite.to(blob[2], 2.8, { x: x, y: -y, ease: Elastic.easeOut.config(1, 0.1) });
      TweenLite.to(blob[3], 2.8, { x: -x, y: -y, ease: Elastic.easeOut.config(1, 0.1) });
      TweenLite.to(filter, 5, { onUpdate: function() { filter.setAttribute('x', 0); }});
    });
  }

  [...document.querySelectorAll('.button--blob')].forEach((el) => initBtBlob(el))
  */
}
